var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundsLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67509",
    "data-name": "Group 67509",
    transform: "translate(-332 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22412",
    "data-name": "Rectangle 22412",
    width: 72,
    height: 72,
    transform: "translate(332 756)",
    fill: "#ddf8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-lock",
    transform: "translate(308.667 772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67453",
    "data-name": "Group 67453",
    transform: "translate(42.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67452",
    "data-name": "Group 67452",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80505",
    "data-name": "Path 80505",
    d: "M71,14.04V11.667a11.667,11.667,0,1,0-23.333,0V14.04a8.333,8.333,0,0,0-5,7.627v10A8.343,8.343,0,0,0,51,40H67.667A8.343,8.343,0,0,0,76,31.667v-10A8.333,8.333,0,0,0,71,14.04ZM51,11.667a8.333,8.333,0,1,1,16.667,0v1.667H51Zm21.667,20a5,5,0,0,1-5,5H51a5,5,0,0,1-5-5v-10a5,5,0,0,1,5-5H67.667a5,5,0,0,1,5,5Z",
    transform: "translate(-42.667 0)",
    fill: "#1d98b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80506",
    "data-name": "Path 80506",
    d: "M236.333,298.667a1.667,1.667,0,0,0-1.667,1.667v3.333a1.667,1.667,0,0,0,3.333,0v-3.333A1.667,1.667,0,0,0,236.333,298.667Z",
    transform: "translate(-219.667 -275.333)",
    fill: "#1d98b5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundsLocked);
export default __webpack_public_path__ + "static/media/funds-locked.22c9337d3965c32d0dcde31fbed8b47f.svg";
export { ForwardRef as ReactComponent };